import Vue from 'vue';
import Router from 'vue-router';
import Main from '../views/Main.vue';
import About from '../views/About.vue';
import GynStory from '../views/GynStory.vue';
import GynStoryDetail from '../views/GynStoryDetail.vue';
import News from '../views/News.vue';
import NewsDetail from '../views/NewsDetail.vue';
import Event from '../views/Event.vue';
import EventDetail from '../views/EventDetail.vue';
import Notice from '../views/Notice.vue';
import NoticeDetail from '../views/NoticeDetail.vue';
import Counseling from '../views/Counseling.vue';
import Login from '../views/admin/Login.vue';
import AdminIndex from '../views/admin/Index.vue';
import AdminIntro from '../views/admin/Intro.vue';
import AdminFaq from '../views/admin/Faq.vue';
import AdminNews from '../views/admin/News.vue';
import AdminQna from '../views/admin/Qna.vue';
import AdminEvent from '../views/admin/Event.vue';
import AdminNotice from '../views/admin/Notice.vue';
import AdminStory from '../views/admin/Story.vue';
import AdminDecide from '../views/admin/Decide.vue';
import AdminLabNotice from '../views/admin/LabNotice.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: to.hash, offset: { y: 130 } });
        }, 300);
      });
    }
    if (savedPosition) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(savedPosition);
        }, 100);
      });
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: Main,
    },
    {
      path: '/about',
      component: About,
    },
    {
      path: '/campaign',
      redirect: '/campaign/gyn-story',
    },
    {
      path: '/campaign/gyn-story',
      component: GynStory,
    },
    {
      path: '/campaign/gyn-story/:detail',
      component: GynStoryDetail,
    },
    {
      path: '/board',
      redirect: '/board/news',
    },
    {
      path: '/board/news',
      component: News,
    },
    {
      path: '/board/news/:detail',
      component: NewsDetail,
    },
    {
      path: '/board/event',
      component: Event,
    },
    {
      path: '/board/event/:detail',
      component: EventDetail,
    },
    {
      path: '/notice',
      component: Notice,
    },
    {
      path: '/notice/:detail',
      component: NoticeDetail,
    },
    {
      path: '/counseling',
      component: Counseling,
    },
    {
      path: '/web/page/story.asp',
      redirect: '/campaign/gyn-story',
    },
    {
      path: '/web/page/story01.asp',
      redirect: '/campaign/gyn-story',
    },
    {
      path: '/web/event/180101',
      redirect: '/campaign/i-decide',
    },
    {
      path: '/web/page',
      redirect: '/',
    },
    {
      path: '/admin/login',
      component: Login,
      meta: { clean: true },
    },
    {
      path: '/admin',
      component: AdminIndex,
      meta: { clean: true },
      children: [
        {
          path: 'faq',
          component: AdminFaq,
        },
        {
          path: 'news',
          component: AdminNews,
        },
        {
          path: 'qna',
          component: AdminQna,
        },
        {
          path: 'event',
          component: AdminEvent,
        },
        {
          path: 'notice',
          component: AdminNotice,
        },
        {
          path: 'labNotice',
          component: AdminLabNotice,
        },
        {
          path: 'story',
          component: AdminStory,
        },
        {
          path: 'decide',
          component: AdminDecide,
        },
        {
          path: '',
          component: AdminIntro,
        },
        {
          path: '*',
          component: AdminIntro,
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js